import SectionHeading from "@/components/base/SectionHeading";
import { principles, testimonials } from "@/mocks/spotlight";

export default function BrandSection() {
  return (
    <section id="about" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-center lg:gap-12">
          <div className="lg:col-span-5">
            <div className="h-72 w-full overflow-hidden rounded-lg border border-background-200 lg:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20editorial%20workspace%20scene%20with%20open%20notebook%20and%20coffee%20cup%20on%20cream%20colored%20desk%2C%20muted%20crimson%20accents%2C%20soft%20natural%20light%2C%20minimalist%20magazine%20still%20life%2C%20no%20text&width=900&height=1100&seq=hl-about-brand&orientation=portrait"
                alt="黑料看点话题编辑与观点整理工作场景"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <SectionHeading
              eyebrow="About Us"
              title="关于黑料看点"
              desc="黑料看点是一个聚焦网络热点的话题讨论与争议热评聚合平台。我们不生产结论，只把讨论摆到台面上。"
            />
            <div className="space-y-4 text-sm md:text-base leading-relaxed text-foreground-700">
              <p>
                每一天，都有大量话题在不同平台同时发酵，观点四散、立场对立，普通人很难看清全貌。黑料看点要做的，是把这些分散的讨论收拢到一处，用统一的视角呈现出来。
              </p>
              <p>
                我们相信，一个话题的完整样貌，应该同时包含支持与反对两方的理由。所以站内每一个话题，都会尽量把正反观点并列展示，而不是只推给你情绪最强的那个声音。看清争议，比站队更重要。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((item) => (
                <div key={item.id} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-20">
          <SectionHeading
            eyebrow="Community Voice"
            title="用户怎么说"
            desc="来自长期围观讨论的用户反馈，也是我们持续打磨呈现方式的动力。"
          />
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {testimonials.map((item) => (
              <figure
                key={item.id}
                className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-6 w-6 items-center justify-center text-accent-600">
                  <i className="ri-double-quotes-l text-xl"></i>
                </span>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.text}
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-semibold text-primary-700">
                    {item.name.slice(0, 1)}
                  </span>
                  <span className="leading-tight">
                    <span className="block font-label text-sm font-medium text-foreground-900">
                      {item.name}
                    </span>
                    <span className="block font-label text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}